import React from "react";
import Login from "./Login";
import { useNavigate } from "react-router-dom";
import logotipo_recortado from "../images/logotipo-horizontal_con-nombre_recortado.png";

const WelcomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", fontFamily: "sans-serif", }}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "3rem", marginTop: "3em", }}>
        <img src={logotipo_recortado} alt="Logo DISFAGIAPP recortado" style={{ maxWidth: "300px", height: "auto" }}/>
      </div>

      {/* Login */}
      <div>
        <Login />
      </div>

      {/* Registro */}
      <div style={{ marginTop: "3rem", textAlign: "center" }}>
        <p>¿No tienes cuenta? </p>
        <button
          onClick={() => navigate("/register")}
          style={{
            backgroundColor: "#5986bd",
            color: "white",
            padding: "0.5rem 1rem",
            borderRadius: "0.375rem",
            border: "none",
            cursor: "pointer",
            fontWeight: "bold",
            marginTop: "0.5rem",
          }}
        >
          Registrarse
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;